var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.messages.length > 0)?_c('ul',{staticClass:"ax-form-success list-unstyled"},_vm._l((_vm.messages),function(message,i){return _c('li',{key:i,staticClass:"ax-form-success__message"},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }